export enum RoundingDirection {
  /** Round to nearest */
  RoundToNearest = '0',
  /** Round down */
  RoundDown = '1',
  /** Round up */
  RoundUp = '2',
}
